export class CustomizeStringsService {

  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static uppercaseAndRemoveSpaces(string) {
     return string.split(' ').join('');
  }

  static removeNonDigitCharacters(string) {
    return string.replace(/\D/g, '');
  }

  static removeLeadingZero(string) {
    if ('/^00+/'.match(string)) {
      return string.replace(/^0+/, '0');
    } else {
      return string.replace(/^0+/, '');
    }
  }
}
